import {Action, Module, Mutation, VuexModule} from "vuex-module-decorators";
import {INewProjectMetadata, IProjectMetadata, IR23ReportMetadata} from "@/interfaces/report";

import {User} from "@/interfaces/user";
import {$http} from "@/main";
import {AxiosResponse} from "axios";
import router from "@/router";
import {IPxError, processReason} from "@/lib/util/errors";
import {BaseScenarioType, IBaseScenario} from "@/lib/types/IBaseScenario";

// const transformR23ReportMetadata = (report: IR23ReportMetadata): IProjectMetadata => {
//   return {
//     id: report.r23ReportId,
//     name: report.reportTitle,
//     user: null,
//
//     // TODO: some kind of validation of ISO date format
//     created: report.created,
//     modified: report.updated,
//     visible: report.visible
//   };
// };


// export const testProjectMetadata: IR23ReportMetadata = {
//   ownerEmail: 'ben@trisightengineering.com',
//   ownerFirstName: 'ben',
//   ownerLastName: 'ciavola',
//   r23ReportId: 1,
//   reportTitle: "King Street",
//   created: new Date(2019, 5, 20).toISOString(),
//   updated: new Date(Date.now()).toISOString(),
//   visible: true,
// };

@Module({
  // dynamic:true,
  // store: store,
  name: "project",
  namespaced: true,
})
export class ProjectStore extends VuexModule {
  /*
   Tab management for scenario selection
   */

  selectedScenarioTab: BaseScenarioType = BaseScenarioType.design;

  @Mutation
  setScenarioTab(scenarioType: BaseScenarioType) {
    this.selectedScenarioTab = scenarioType;
  }

  /*
   A central location for http httpErrors to go
   */
  httpErrors: IPxError[] = [];

  @Mutation
  pushHttpErrors(reason: { response: AxiosResponse }) {
    this.httpErrors = processReason(reason);
  }

  @Mutation
  pushError(error: IPxError) {
    this.httpErrors.push(error);
  }

  @Mutation
  clearErrors() {
    this.httpErrors = [];
  }

  /*
   PXSuite
   */
  // availableProjects: IProjectMetadata[] = [
  // transformR23ReportMetadata(testProjectMetadata),
  // ];

  // @Mutation
  // setAvailableProjects(metadataList: IProjectMetadata[]){
  //   this.availableProjects = metadataList;
  // }

  currentProjectId: number = -1;

  @Mutation
  setProjectId(id: number) {
    this.currentProjectId = id;
  }

  @Action({rawError: true})
  getProjectMetadata(id: number): Promise<IProjectMetadata> {
    // return this.availableProjects[0]
    return $http.get(`/project/${id}`).then((response) => response.data).catch((reason) => {
      this.pushHttpErrors(reason);
      router.push("/projects/");
    });
  }

  @Action({rawError: true})
  loadAvailableProjects() {
    this.clearErrors();
    return $http.get("projects").then((result) =>
      // this.setAvailableProjects(result.data);
      result.data);
  }

  @Action({rawError: true})
  createProject(metadata: INewProjectMetadata): Promise<IProjectMetadata | null> {
    this.clearErrors();
    return $http.post("project/new", metadata).then(
      (response) => {
        // console.log("Raw meta response", response);
        if (response.data.project) {
          // There was an existing project
          return response.data.project;
        }
        // New project created
        return response.data;
      },
    ).catch((reason) => {
      if (reason.response.data.error) {
        this.pushError(reason.response.data.error);
        this.pushHttpErrors(reason);
      }
      this.pushHttpErrors(reason);
      return false;
    });
  }

  @Action({rawError: true})
  updateProject(metadata: IProjectMetadata): Promise<IProjectMetadata | null> {
    this.clearErrors();
    return $http.put(`project/${metadata.id}`, metadata).then(
      (response) => response.data,
    ).catch((reason) => reason);
  }

  @Action({rawError: true})
  loadProjectScenarios(id: number): Promise<IProjectMetadata | null> {
    this.clearErrors();
    return $http.get(`project/scenarios/${id}`).then((response) => {
      const scenarios = response.data;
      return scenarios;
    })
      .catch((reason) => this.pushHttpErrors(reason));
  }

  @Action({rawError: true})
  deleteProject(id: number): Promise<Boolean> {
    this.clearErrors();
    return $http.delete(`project/${id}`).then((response) => response.status === 204);
  }

  @Action({rawError: true})
  loadSharedScenarios() {
    return $http.get("shared").then((response) => response.data);
  }

  @Action({rawError: true})
  createSharedScenario(data: { scenario: IBaseScenario, targetUserEmail: string }) {
    const {scenario} = data;
    const {targetUserEmail} = data;

    console.log(`Sharing scenario ${scenario.name} with ${targetUserEmail}`);
    return $http.post(`/shared/new`, {
      targetUser: targetUserEmail,
      scenario: scenario
    });
  }

  @Action({rawError: true})
  deleteSharedScenario(id: number): Promise<Boolean> {
    this.clearErrors();
    return $http.delete(`shared/${id}`).then((response) => response.status === 204);
  }


  /*
   Legacy PXpress
   */

  @Action({rawError: true})
  loadLegacyReportContent(r23ReportId: number) {
    this.clearErrors();
    return $http.get(`legacy/report-content/${r23ReportId}`).then((result) => JSON.parse(result.data.reportContent));
  }

  availableReportsLegacy: IR23ReportMetadata[] = [
    // testProjectMetadata
  ];

  @Mutation
  setAvailableReportsLegacy(metadataList: IR23ReportMetadata[]) {
    this.availableReportsLegacy = metadataList;
  }

  @Action({rawError: true})
  checkForLegacyReports(user: User | null) {
    this.clearErrors();
    if (user !== null) {
      return $http.get("legacy/reports-available/").then((result) =>
        // console.log("available:", result.data);
        result.data).catch((reason) => this.pushHttpErrors(reason));
    }
    return false;
  }

  @Action({rawError: true})
  loadAvailableReportsLegacy() {
    this.clearErrors();

    $http.get<IR23ReportMetadata[]>("legacy/reports/").then((result) => {
      this.setAvailableReportsLegacy(result.data);

      // console.log(this.availableProjects)
    }).catch((reason) => {
      console.log(reason);
    });
  }

  @Action({rawError: true})
  updateLegacyReportMetadata(meta: IR23ReportMetadata) {
    this.clearErrors();
    return $http.put(`legacy/report-meta/${meta.r23ReportId}`, meta).then((response) => response.data);
  }

  //
  // get currentR23ReportMetadata(): IR23ReportMetadata {
  //   return this.availableReportsLegacy[0]
  // }
  //
  // get currentR23Report(): IR23Report {
  //   return exampleAsphaltDesignR23Report
  // }
}


/*
 Test data
 */
